module.exports = __webpack_public_path__ + "static/img/freeImg.455abbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/freeImg.png
// module id = Glv+
// module chunks = 0